/* global pendo */
import { useEffect, useState, createContext } from "react";
import { Toaster } from "react-hot-toast";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./TasksRoot.css";
import { selectUser } from "../../redux/features/appData";
import { WazToolbar } from "../wazawan/toolbar/WazToolbar";
import { AppHeader } from "../app/app-header/AppHeader";

type TasksRootProps = {

};

export const TasksRoot = ({}: TasksRootProps) => {


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const storeUser = useSelector(selectUser);

  if (storeUser) {
    document.body.className = storeUser.theme;
  }

  console.log("[TasksRoot/main] storeUser: ", storeUser);

  return (
        <>
            <div id="root">
                <WazToolbar viewingApp={true}/>
                
                <div className="tasks-contents">
                    <AppHeader />
                    <div className="tasks-body">
                        <Outlet context={[]} />
                    </div>
                </div>
                
            </div>

            {/* <Toaster /> */}
        </>
  );
}
